import { LoggingTypes, NewRelicAttributes } from '../../models';

export abstract class NewRelicService {
  abstract initialize(): void;

  abstract isStarted(): boolean;

  abstract recordHttpFailure(
    url: string,
    httpMethod: string,
    startTime: number,
    endTime: number,
    failureCode: number
  ): void;

  abstract noticeHttpTransaction(
    url: string,
    httpMethod: string,
    statusCode: number,
    startTime: number,
    endTime: number,
    bytesSent: number,
    bytesReceived: number,
    responseBody?: string
  ): void;

  abstract recordMetric(name: string, category: string, value?: number): void;

  abstract recordCustomEvent(
    eventType: string,
    eventName?: string,
    attributes?: NewRelicAttributes
  ): boolean;

  abstract setAttribute(name: string, value: string | number | boolean): boolean;

  abstract startInteraction(interactionName: string): string | null;

  abstract endInteraction(interactionId: string): void;

  abstract log(log: string, type?: LoggingTypes);
}
